<template>
  <a-layout class='index animated fadeIn'>
    <SmallSquare content='查看导购扫码活动领奖明细记录；默认显示近30天内的记录；红包“发放失败”表示由于商户余额不足、用户帐号异常、网络暂时繁忙等原因导致用户接收不到红包的情况。 登录微信商户后台查看商户余额。
扫码领奖明细记录非实时显示，记录在领奖一分钟后显示。' :padding='true'></SmallSquare>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item ref="" label="活动" name="">
          <a-input placeholder="请输入活动名称" style='width:240px' v-model:value="search.activity"></a-input>
        </a-form-item>
        <a-form-item label="" name='user_key_type'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select style="width: 30%" v-model:value="search.user_key_type">
              <a-select-option value="clerk_name">领奖用户</a-select-option>
              <a-select-option value="member_name">微信昵称</a-select-option>
            </a-select>
            <a-input style="width: 70%" placeholder="请输入关键词进行搜索" v-model:value="search.user_keyword" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="" name='code_key_type'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select style="width: 30%" v-model:value="search.code_key_type">
              <a-select-option value="batch_sn">码批次</a-select-option>
              <a-select-option value="product_code">码ID</a-select-option>
              <a-select-option value="code_sn">流水号</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.code_keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item ref="" label="手机号" name="">
          <a-input placeholder="请输入导购手机号" style='width:240px' v-model:value="search.clerk_phone"></a-input>
        </a-form-item>
        <a-form-item label="奖项内容" name='award_key_type'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select style="width: 30%" v-model:value="search.award_key_type">
              <a-select-option value=''>全部</a-select-option>
              <a-select-option value='is_point'>积分</a-select-option>
              <a-select-option value='is_bonus'>红包</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.award_keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="中奖状态" name='is_award'>
          <a-select style="width: 120px" placeholder="请选择" v-model:value="search.is_award">
            <a-select-option value=''>全部</a-select-option>
            <a-select-option :value='1'>中奖</a-select-option>
            <a-select-option :value='0'>未中奖</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="发放状态" name='award_status'>
          <a-select style="width: 120px" placeholder="请选择" v-model:value="search.award_status">
            <a-select-option value=''>全部</a-select-option>
            <a-select-option :value='4'>待领取</a-select-option>
            <a-select-option :value='3'>发放中</a-select-option>
            <a-select-option :value='1'>发放成功</a-select-option>
            <a-select-option :value='2'>发放失败</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="用户身份" name='clerk_type'>
          <a-select style="width: 120px" placeholder="请选择" v-model:value="search.clerk_type">
            <a-select-option value=''>全部</a-select-option>
            <a-select-option :value='1'>店老板</a-select-option>
            <a-select-option :value='2'>店长</a-select-option>
            <a-select-option :value='3'>店员</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="奖项来源" name='is_director_award'>
          <a-select style="width: 120px" placeholder="请选择" v-model:value="search.is_director_award">
            <a-select-option value=''>全部</a-select-option>
            <a-select-option :value='1'>同步发奖</a-select-option>
            <a-select-option :value='0'>自主扫码</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="中奖时间" name='time'>
          <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="onChange" v-model:value="time" @calendarChange="panelChange" :disabled-date="disabledDate" />
        </a-form-item>
        <a-form-item label="审核状态" name='scan_award_permit_status'>
          <a-select style="width: 120px" placeholder="请选择" v-model:value="search.scan_award_permit_status">
            <a-select-option value=''>全部</a-select-option>
            <a-select-option :value='1'>待审核</a-select-option>
            <a-select-option :value='0'>无需审核</a-select-option>
            <a-select-option :value='2'>已通过</a-select-option>
            <a-select-option :value='3'>已拒绝</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
          <a-button v-has:guideAwardLogsExport="exportTable" class='m-l-10'>导出</a-button>
          <a-button v-has:guideAwardLogsExamine="guideAExamines" type="primary" class='m-l-10'>批量审核</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
        <div class="s_flex_ali m-b-20">
          <div class="m-r-30 s_cd41">
            <span class="label s_c666">领奖用户数：</span><span>{{awardCount.award_user}}</span>
          </div>
          <div class="m-r-30 s_cd41">
            <span class="label s_c666">积分发放总量：</span><span>{{awardCount.point_num}}</span>
          </div>
          <div class="m-r-30 s_cd41">
            <span class="label s_c666">红包发放总额：</span><span>{{awardCount.money_num}}元</span>
          </div>
        </div>
        <a-table :row-selection="rowSelection" :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list' class='tableFixBox' :scroll="{ x: 'max-content'}">
          <template v-slot:clerk_name="{ record }">
            <p>{{record.clerk_name}}</p>
            （{{record.clerk_type_text}}）
          </template>
          <template v-slot:member="{ record }">
            <div class="s_flex_ali">
              <img class="width-50 height-50 m-r-15" :src="record.member_img ? record.member_img : ''" alt="" />
              <div>
                <p>{{record.member_name || '-'}}</p>
              </div>
            </div>
          </template>
          <template v-slot:code_sn="{ record }">
            <p>{{record.product_code}}</p>
            （{{record.code_sn}}）
          </template>
          <template v-slot:award_name="{ record }">
            <p>{{record.award_name || '-'}}</p>
          </template>
          <template v-slot:award_content_arr="{ record }">
            <div v-if='record.award_arr.length'>
              <p v-for="(item,index) in record.award_arr" :key='index'>{{item}}</p>
            </div>
            <p v-else>-</p>
          </template>
          <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:guideAwardLogsDetail="()=>{showMore = true;scan_id = record.scan_award_id}">详情</a>
            <a v-if="record.scan_award_permit_status==1" href="javascript:;" v-has:guideAwardLogsExamine="()=>{showMoreExa = true;scan_id = record.scan_award_id}" class="m-l-10">审核</a>
          </template>
        </a-table>
        <a-pagination :show-total="total => `总数:${total} `" :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
      </div>
    </a-card>
  </a-layout>
  <!-- 活动弹窗 -->
  <a-modal v-model:visible="activityVisible" centered style="width:700px" :width='1000' :footer="null">
    <selectActivity v-on:select="activitySelect" :checkout='false' />
  </a-modal>
  <!-- 商品弹窗 -->
  <a-modal :keyboard="false" v-model:visible="productVisible" centered :footer="null" style="width:700px" :width='1000'>
    <selectGood v-on:select="goodSelect" :selectList='[{id:search.product_id}]'></selectGood>
  </a-modal>
  <a-modal :keyboard="false" title="扫码明细详情" centered v-model:visible="showMore" :width='1200' :footer="null" destroyOnClose>
    <scanMore type='activity' typename='distributor' :id='scan_id'></scanMore>
  </a-modal>
  <a-modal :keyboard="false" title="审核信息" centered v-model:visible="showMoreExa" :width='1000' :footer="null" destroyOnClose>
    <examine typename='distributor' :id='scan_id' @showclose='showclose'></examine>
  </a-modal>
  <a-modal :keyboard="false" v-model:visible="isExamines" centered title="批量审核" :width='500' @ok='comfirmeax'>
    <a-form ref="ruleForm" :model="exaform" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="scan_award_permit_statuse" label="处理方式" name="scan_award_permit_status">
        <a-radio-group class="mb10" v-model:value="exaform.scan_award_permit_status" @change="onChange">
          <a-radio :value="2">
            <span class="s_c333   s_lin_h35">通过</span>
          </a-radio>
          <a-radio :value="3">
            <span class="s_c333   s_lin_h35">拒绝</span>
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item ref="award_fail_reason" label="拒绝原因" name="award_fail_reason" v-if="exaform.scan_award_permit_status == 3">
        <a-textarea v-model:value="exaform.award_fail_reason" style='width:300px' placeholder="请输入拒绝原因" :rows="4" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
import { iscode } from "@/utils/app";
import {
  getdealer_scan_awardList,
  getdealer_scan_awardExport,
  getdealer_scan_awardCount,
  setGuidedealerbatchAudit,
} from "@/api/guide";
import scanMore from "../scanLogs/detail.vue";
import examine from "./examine.vue";
import { message } from "ant-design-vue";
const def = {
  page: 1,
  page_num: 10,
  start_time: "",
  end_time: "",
  activity: "",
  product: "",
  user_key_type: "clerk_name",
  user_keyword: "",
  code_key_type: "code_sn",
  code_keyword: "",
  award_key_type: "is_bonus",
  award_keyword: "",
  award_status: "",
  is_award: "",
  is_director_award: "",
  clerk_type: "",
  clerk_phone: "",
  scan_award_permit_status: "",
};
export default {
  name: "award",
  components: { scanMore, examine },
  setup() {
    const state = reactive({
      vipList: [],
      listLoading: false,
      total: 0,
      visible: false,
      time: [],
      totalData: {},
      scan_id: "",
      showMore: false,
      offsetDays: 2678400 * 1000, //最多选择范围31天ms,
      showMoreExa: false,
      isExamines: false,
      rules: {
        award_fail_reason: [{ required: true, message: "请输入拒绝原因" }],
        scan_award_permit_status: [
          { required: true, message: "请选择处理方式" },
        ],
      },
    });
    const ruleForm = ref();
    const exaform = ref({
      scan_award_permit_status: 2,
      award_fail_reason: "",
    });
    let list = ref();
    let columns = [
      {
        title: "导购活动",
        dataIndex: "activity_name",
        key: "activity_name",
      },
      {
        title: "领奖用户",
        dataIndex: "clerk_name",
        key: "clerk_name",
        slots: { customRender: "clerk_name" },
      },
      {
        title: "微信昵称",
        dataIndex: "member",
        key: "member",
        slots: { customRender: "member" },
      },
      {
        title: "码ID",
        dataIndex: "product_code",
        key: "product_code",
        slots: { customRender: "code_sn" },
      },
      {
        title: "奖项名称",
        dataIndex: "award_name",
        key: "award_name",
        slots: { customRender: "award_name" },
      },
      {
        title: "奖项内容",
        dataIndex: "award_content_arr",
        key: "award_content_arr",
        slots: { customRender: "award_content_arr" },
      },
      {
        title: "中奖时间",
        dataIndex: "created_time",
        key: "created_time",
      },
      {
        title: "发放状态",
        dataIndex: "award_status_title",
        key: "award_status_title",
      },
      {
        title: "审核状态",
        dataIndex: "scan_award_permit_status_text",
        key: "scan_award_permit_status_text",
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const awardCount = ref({});
    const selectedRowKey = ref([]);
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKey.value = [];
        selectedRows.forEach((item) => {
          selectedRowKey.value.push(item.scan_award_id);
        });
        console.log(selectedRowKey.value);
      },
      // onSelect: (record, selected, selectedRows) => {
      //   console.log(record, selected, selectedRows);
      // }
    };
    const getCount = async () => {
      let result = await getdealer_scan_awardCount({ ...search.value })
        .then((res) => res.data)
        .catch((error) => error);
      awardCount.value = result.data;
    };
    const initData = async () => {
      state.listLoading = true;
      list.value = [];
      let res = await getdealer_scan_awardList({ ...search.value })
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(res)) {
        list.value = res.data;
        // state.totalData = res.total;
        state.total = res.meta.total;
      }
      getCount();
    };
    const search = ref({ ...def });
    const moment = inject("momentTime");
    const disabledCurrent = ref("");
    const disabledDate = (current) => {
      if (!disabledCurrent.value) return current > moment().endOf("day");
      // return disabledCurrent.value < current
      return (
        (current &&
          current <
            moment(disabledCurrent.value).subtract(1, "M").startOf("day")) ||
        current > moment(disabledCurrent.value).add(1, "M").endOf("day")
      );
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    onMounted(() => {
      initData();
    });
    const $router = inject("$router");
    // 时间筛选
    const panelChange = (e) => {
      disabledCurrent.value = e[0];
    };
    const onChange = (e) => {
      if (!e) {
        search.value.start_time = "";
        search.value.end_time = "";
        return;
      }
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    //批量审核
    const guideAExamines = async () => {
           exaform.value={}
      if (selectedRowKey.value.length == 0) {
        message.error("请选择需要审核的记录");
        return;
      }
      state.isExamines = true;
    };
    //批量审核确定
    const comfirmeax = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          const hide = message.loading("正在加载中...", 0);
          let result = await setGuidedealerbatchAudit({
            ...exaform.value,
            scan_award_ids: selectedRowKey.value,
          })
            .then((res) => res.data)
            .catch((error) => error);
          setTimeout(hide);
          if (iscode(result, true)) {
            selectedRowKey.value=[];
            initData();
            state.isExamines = false;
          }
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    // 活动弹窗
    const activityVisible = ref(false);
    const activitySelect = (data) => {
      search.value.activity_id = data.activity_id;
      search.value.activity_name = data.activity_name;
      activityVisible.value = false;
    };
    // 商品弹窗
    const productVisible = ref(false);
    const goodSelect = (data) => {
      search.value.product_name = data.product_name;
      search.value.product_id = data.id;
      productVisible.value = false;
    };
    const showclose = (data) => {
      state.showMoreExa = data;
    };

    // 选择省市区
    const citychange = (e) => {
      search.value.province_id = e[0] || "";
      search.value.city_id = e[1] || "";
      search.value.district_id = e[2] || "";
    };
    // 切换是否中奖
    const changIsAward = (e) => {
      if (e == 0) {
        search.value.award_status = "";
      }
    };
    // 导出
    const exportTable = async () => {
      const hide = message.loading("正在加载中...", 0);
      var json = JSON.parse(JSON.stringify(search.value));
      delete json.page;
      delete json.page_num;
      let result = await getdealer_scan_awardExport(json)
        .then((res) => res.data)
        .catch((error) => error);
      setTimeout(hide);
      if (iscode(result, true)) {
        window.open(result.data.url);
      }
    };
    return {
      disabledDate,
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      activityVisible,
      activitySelect,
      productVisible,
      goodSelect,
      citychange,
      changIsAward,
      exportTable,
      awardCount,
      panelChange,
      showclose,
      comfirmeax,
      guideAExamines,
      rowSelection,
      exaform,
      ruleForm
    };
  },
};
</script>